var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('page',{staticClass:"profileView"},[_c('div',[_c('h4',[_vm._v(_vm._s(_vm.$t('profile.view.updateForm')))]),_c('profile-form')],1),_c('div',[_c('h4',[_vm._v(_vm._s(_vm.$t('profile.view.newPasswordForm')))]),_c('new-password-form')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }